import { map } from 'lodash';
import { ISearchListColumn } from '../../IColumnExtensionType';
import { IColumnSelectControl, OrderByProps } from '@msrceng/component';

/**
 * Hook to get the columns for the SearchDetailsList from the
 * data columns including handling the invesion of sorting.
 */
export const useSearchDetailsListColumnsFromDataColumns = ({
  orderBy,
  selectedColumnList,
}: {
  orderBy: OrderByProps | undefined;
  selectedColumnList:
    | IColumnSelectControl<ISearchListColumn>['selectedColumnList']
    | undefined;
}): ISearchListColumn[] =>
  map(selectedColumnList, c => applyOrderByToColumn(c, orderBy));

const applyOrderByToColumn = (
  column: ISearchListColumn,
  orderBy: OrderByProps | undefined
): ISearchListColumn => {
  if (!orderBy?.key && !column) {
    return column;
  }

  if (column.key === orderBy?.key) {
    return {
      ...column,
      isSorted: column.key === orderBy?.key,
      isSortedDescending: orderBy?.ascending === false,
    };
  }
  return column;
};
